import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import NewWeeklyClass from './NewWeeklyClass.js';
import { useTheme } from '../../../Context/ThemeContext';

export default function WeeklyClassBox(props) {
  const {
    rendering,
    setRendering,
    today,
    standardDate,
    isLoading,
    setIsLoading,
    isInProgress,
    setIsInProgress,
    scheduleData,
    breakTimeData,
    changedTeachers,
    canceledSchedules,
    setClickDate,
    onClickDeleteButton,
    onClickScheduleDetail,
    onClickPlusColumn,
    selectedCoaches = [] // 기본값 설정
  } = props;

  const { isDark } = useTheme();

  const [standardDateList, setStandardDateList] = useState([]);

  // 매 주차 첫번째날 뽑기 //
  useEffect(() => {
    const weekStartDates = [];
    const currentMonth = standardDate.format('MM');

    weekStartDates.push(standardDate.clone());

    let nextStandardDate = standardDate.clone().add(7, 'days');

    while (nextStandardDate.format('MM') === currentMonth) {
      weekStartDates.push(nextStandardDate.clone());
      nextStandardDate.add(7, 'days');
    }

    setStandardDateList(weekStartDates);
  }, [standardDate])

  return (
    <TopLevelWrapper $isDark={isDark}>
      {
        standardDateList.map((data, index) => (
          <WeeklyWrapper key={'WeeklyDates-' + index}>
            <NewWeeklyClass
              index={index}
              rendering={rendering}
              setRendering={setRendering}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              isInProgress={isInProgress}
              setIsInProgress={setIsInProgress}
              scheduleData={scheduleData}
              breakTimeData={breakTimeData}
              changedTeachers={changedTeachers}
              canceledSchedules={canceledSchedules}
              today={data}
              setClickDate={setClickDate}
              onClickDeleteButton={onClickDeleteButton}
              onClickScheduleDetail={onClickScheduleDetail}
              onClickPlusColumn={onClickPlusColumn}
              selectedCoaches={selectedCoaches} />
            {/* {standardDateList.length !== index + 1 && <DivisionLine />} */}
          </WeeklyWrapper>
        ))
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-bottom: 20px;
  margin-bottom: 96px;

  width: 1020px;

  border-radius: 20px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
  
  transition: all 0.3s ease-in-out;
`;

const WeeklyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 25px;

  width: 974px;
  height: 2px;

  border-radius: 4px;
  background-color: rgba(255, 139, 72, 0.5);
`;
